import { publicAPI } from '../public_api/publicAPI'
import { useState } from 'react'
import useSWR from 'swr'

export const useSiteRequests = () => {
  const getProductsStock = async articlesArr => {
    const query = articlesArr.join(';')
    try {
      const res = await publicAPI.getPositionsStock(query)
      const { status, data } = res.data.result
      if (status === 'success') {
        // setData(data)
      }
    } catch (e) {
      throw e
    }
  }
  const { data, error, isLoading } = useSWR(``, getProductsStock)



  return {
    getProductsStock,
    data
  }
}
